import { useNavigate } from "react-router";

const WeekendCard = ({ service }: { service: any }) => {
  const navigate = useNavigate();

  return (
    <div
      className="weekend-card p-2"
      onClick={() => navigate(`/services/${service?.URL}/`)}
    >
      <div className="weekend-card-pic">
        <img src={service?.Image} alt={service?.Title} />
      </div>
      <h5 className="mt-2">
        <a href="#">{service?.Title}</a>
      </h5>
    </div>
  );
};

export default WeekendCard;
